<template>
    <!-- 面包屑组件 -->
    <el-breadcrumb 
    :separator="separator"
    :separator-class="separatorIcon"
    :replace="replace"
    >
        <template v-for="(br,brInx) in breadcrumbList">
            <el-breadcrumb-item :to="br.path" :replace="br.replace" :key="br.text + brInx">
                {{br.text}}
            </el-breadcrumb-item>
        </template>
    </el-breadcrumb>
</template>
<script>
export default {
    name:"VelBreadcrumb",
    props:{
        separator:String,
        separatorIcon:String,
        isReplace:Boolean,
        breadcrumbList:{
            type:Array,
            required:true,
        }
    },
    data() {
        return {
            replace:false
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isReplace ? this.replace = true : this.replace
        },
    }
}
</script>